import { render, staticRenderFns } from "./ModalAspectos.vue?vue&type=template&id=69d363b4"
import script from "./ModalAspectos.vue?vue&type=script&lang=js"
export * from "./ModalAspectos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69d363b4')) {
      api.createRecord('69d363b4', component.options)
    } else {
      api.reload('69d363b4', component.options)
    }
    module.hot.accept("./ModalAspectos.vue?vue&type=template&id=69d363b4", function () {
      api.rerender('69d363b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/portal/buscador/ModalAspectos.vue"
export default component.exports